import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconArrowDownStyle0 = gravityIconIndividualCss;

const GravityIconArrowDown = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '58e58ea00e9c19c8b5ee16f7882ad0d04d1eeeaf', color: this.color, size: this.size }, h("svg", { key: '61e0e8cfcfd721b7ff911a232dd77e6da34a1e4b', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '60d3a4ceb797edf1b375158a2fc6e628fd71b8c9', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m11.21 13.79 5.28-5.28a.3.3 0 0 0-.21-.51H5.72a.3.3 0 0 0-.21.51l5.28 5.28a.29.29 0 0 0 .42 0Z", fill: "currentColor" }))));
    }
};
GravityIconArrowDown.style = GravityIconArrowDownStyle0;

export { GravityIconArrowDown as gravity_icon_arrow_down };

//# sourceMappingURL=gravity-icon-arrow-down.entry.js.map